import { render, staticRenderFns } from "./customDropdown.vue?vue&type=template&id=5b9d7df2&scoped=true&"
import script from "./customDropdown.vue?vue&type=script&lang=js&"
export * from "./customDropdown.vue?vue&type=script&lang=js&"
import style0 from "./customDropdown.vue?vue&type=style&index=0&id=5b9d7df2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9d7df2",
  null
  
)

export default component.exports